import * as React from "react";
import type { SVGProps } from "react";
const SvgMosque = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 20v-8.09c.58-.21 1-.76 1-1.41 0-.48-.11-.97-.33-1.39l-.78-1.55c-.34-.68-1.45-.68-1.79 0l-.77 1.55c-.21.43-.33.91-.33 1.4 0 .65.42 1.2 1 1.41v3.09h-1v-2c0-2.97-2.17-5.43-5-5.91v-.27c1.16-.41 2-1.51 2-2.82 0-.55-.45-1-1-1s-1 .45-1 1-.45 1-1 1-1-.45-1-1 .45-1 1-1 1-.45 1-1-.45-1-1-1c-1.65 0-3 1.35-3 3 0 1.3.84 2.4 2 2.82v.27c-2.83.48-5 2.94-5 5.91v2H5v-3.09c.58-.21 1-.76 1-1.41 0-.48-.11-.97-.33-1.39l-.78-1.55c-.34-.68-1.45-.68-1.79 0l-.77 1.55c-.21.43-.33.91-.33 1.4 0 .65.42 1.2 1 1.41v8.09c-.55 0-1 .45-1 1s.45 1 1 1h7c.55 0 1-.45 1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1zM12 9c1.86 0 3.41 1.28 3.86 3H8.14c.45-1.72 2-3 3.86-3m0 7c-1.65 0-3 1.35-3 3v1H5v-3h2c.55 0 1-.45 1-1v-2h8v2c0 .55.45 1 1 1h2v3h-4v-1c0-1.65-1.35-3-3-3"
    />
  </svg>
);
export default SvgMosque;
